import { GripVertical, Layers, Plus, Trash2 } from 'lucide-react'
import { useEditorStore } from '../../../store/editorStore'
import { Button } from '../../common/Button'
import { ColorSwatchPicker } from '../../common/ColorSwatchPicker'
import { EmptyState } from '../../common/States'

export function TabSections() {
  const composition = useEditorStore((s) => s.composition)
  const addSection = useEditorStore((s) => s.addSection)
  const updateSection = useEditorStore((s) => s.updateSection)
  const removeSection = useEditorStore((s) => s.removeSection)
  const reorderSections = useEditorStore((s) => s.reorderSections)

  if (!composition) return null
  const { sections } = composition

  return (
    <div className="p-3 space-y-3">
      <Button
        variant="secondary"
        size="sm"
        className="w-full"
        icon={<Plus size={13} />}
        onClick={() => addSection({ name: `セクション${sections.length + 1}`, color: 'none' })}
      >
        セクションを追加
      </Button>

      {sections.length === 0 ? (
        <EmptyState icon={<Layers size={24} />} title="セクションがありません" />
      ) : (
        <div className="space-y-2" data-testid="section-list">
          {sections.map((sec, idx) => (
            <div
              key={sec.id}
              draggable
              onDragStart={(e) => e.dataTransfer.setData('text/aquacut-section-idx', String(idx))}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                const from = Number(e.dataTransfer.getData('text/aquacut-section-idx'))
                if (!Number.isNaN(from)) reorderSections(from, idx)
              }}
              data-testid="section-row"
              className="rounded border border-ink-border bg-ink-surface2/50 p-2.5 space-y-2"
            >
              <div className="flex items-center gap-1.5">
                <GripVertical size={13} className="text-text-faint cursor-grab shrink-0" />
                <span className="text-[10px] text-text-faint w-4">{idx + 1}</span>
                <div className="flex-1">
                  <input
                    value={sec.name}
                    onChange={(e) => updateSection(sec.id, { name: e.target.value })}
                    placeholder="室名 (ja)"
                    className="w-full rounded bg-ink-bg/60 border border-ink-border px-2 py-1 text-xs"
                  />
                </div>
                <button onClick={() => removeSection(sec.id)} className="text-text-faint hover:text-accent-red p-1">
                  <Trash2 size={13} />
                </button>
              </div>
              <input
                value={sec.nameEn ?? ''}
                onChange={(e) => updateSection(sec.id, { nameEn: e.target.value })}
                placeholder="英名 (例: Inome-rium)"
                className="w-full rounded bg-ink-bg/60 border border-ink-border px-2 py-1 text-xs text-text-muted"
              />
              <ColorSwatchPicker value={sec.color} onChange={(color) => updateSection(sec.id, { color })} />
            </div>
          ))}
        </div>
      )}
      <p className="text-[10px] text-text-faint leading-relaxed">
        セクションはタイムラインのSegmentに割り当てると色分けされます。ドラッグで並べ替え。
      </p>
    </div>
  )
}
